export default __webpack_public_path__ + "static/Black_dragon-31c144a230f5805acf63c6c1e9f00e58.png";